import styled from 'styled-components';

export const Layout = styled.div.attrs({
  className: 'flex h-full flex-col',
})``;

export const Container = styled.div.attrs({
  className:
    'container mx-auto flex min-h-0 max-w-6xl flex-1 flex-col gap-3 overflow-y-auto px-4 py-6',
})``;
